import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root, .MuiDialog-paper': {
    padding: '16px 14px',
    fontFamily: theme.typography.fontFamily,

    [theme.breakpoints.up('md')]: {
      padding: '48px 62px',
    },
  },
  '& .MuiDialogTitle-root': {
    color: '#000',
    fontSize: '22px',
    fontWeight: 600,
    textAlign: 'center',
    padding: '0px',
    marginBottom: '21px',

    [theme.breakpoints.up('md')]: {
      fontSize: '28px',
      marginBottom: '32px',
    },
  },
  '& .MuiDialogContent-root': {
    padding: '0px',
  },
  '& .MuiDialogContentText-root': {
    color: '#000',
    fontSize: '16px',
    fontWeight: 500,
    textAlign: 'center',
    padding: '0px',
    marginBottom: '32px',

    [theme.breakpoints.up('md')]: {
      fontSize: '20px',
      marginBottom: '40px',
    },
  },
  '& .MuiDialogActions-root': {
    padding: '0px',
    gap: '8px',
  },
  '& ol': {
    listStylePosition: 'inside',
    marginLeft: '8px',
  },
}));

export const DialogButtonWide = styled(Button)(({ theme }) => ({
  width: '304px',
  height: '52px',
  fontSize: '16px',
  fontWeight: '700',
  margin: 'auto',
}));

export const ModalDialog = ({
  isOpen,
  topIcon,
  title,
  content,
  description,
  inputField,
  buttons,
  onClose,
  ...props
}) => {
  const hasCloseButton = !!onClose;
  return (
    <StyledDialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-dialog-title"
      {...props}
    >
      {hasCloseButton && (
        <IconButton
          aria-label="Close"
          sx={{
            position: 'absolute',
            right: '19px',
            top: '19px',
            color: '#245284',
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      )}
      {topIcon}
      <DialogTitle
        id="modal-dialog-title"
        sx={{
          ...(hasCloseButton && {
            fontSize: '22px !important',
            color: '#353B52 !important',
            mt: '20px',
          }),
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        {description && <DialogContentText>{description}</DialogContentText>}
        {content}
      </DialogContent>
      {inputField}
      <DialogActions>{buttons}</DialogActions>
    </StyledDialog>
  );
};

export const ModalDialogContainer = ({ children, ...props }) => (
  <Dialog {...props}>{children}</Dialog>
);

export const AdaptiveModalDialog = ({ ...props }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  return <ModalDialog {...props} fullScreen={!isDesktop} />;
};
